import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { Col, Divider, Row, Select, Table } from "antd";
import { StarOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import "./index.css";
import { expenseCategories, HeaderTransactionData } from "./data";
import { Prompt } from "react-router";
import { isEmpty } from "lodash";
import useBeforeUnload from "../../components/Prompting";

const ExpenseTransaction = () => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  const [categories, setCategories] = useState([]);
  const [selectDays, setSelectDays] = useState([]);

  useEffect(() => {
    setCategories({
      value: "All Expenses Categories",
      label: "All Expenses Categories",
    });
  }, []);

  useBeforeUnload({
    when: !isEmpty(categories),
    message: "Are you sure you want to leave?",
  });
  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Expense Transaction | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        {/* <Skeleton.Input
          style={{
            padding: "5px",
            width: "100%",
          }}
          active={true}
          size={"large"}
        > */}
        <Col
          span={24}
          className="border pt-3 pb-3 border-b-1 border-x-0 border-t-0"
        >
          <div className="font-poppins flex pl-[20px]">
            <div className="flex">
              <ArrowLeftOutlined
                // onClick={() => setPageRouting(true)}
                className="font-bold text-[18px]"
              />
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[18px] mt-1 ml-2 font-medium"
              >
                Expense Transaction Report
              </h1>
            </div>
            <div className="flex bg-[#e9e9e9] ml-6 pl-2 pr-2 p-1 rounded-md border-none">
              <StarOutlined
                // onClick={() => setPageRouting(true)}
                className="font-bold text-[16px] mr-2"
              />
              Favorite
            </div>
          </div>
        </Col>

        <Col span={24} className="mt-4">
          <Row className="flex justify-between mb-2 mt-2 ml-1">
            <div className="flex">
              <Select
                style={{
                  width: 250,
                  height: 38,
                  fontSize: "12px",
                  marginLeft: 10,
                  fontFamily: "Poppins",
                }}
                value={categories}
                onChange={(e) => setCategories(e)}
                placeholder="Select Categories"
                dropdownRender={(menu) => (
                  <>
                    <h1 className="ml-2 bg-[lightgray]">Categories</h1>
                    <Divider
                      style={{
                        margin: "8px 0",
                      }}
                    />
                    {menu}
                  </>
                )}
                options={expenseCategories}
              />
              <Select
                style={{
                  width: 250,
                  fontSize: "12px",
                  height: 38,
                  marginLeft: 10,
                  fontFamily: "Poppins",
                }}
                value={selectDays}
                onChange={(e) => setSelectDays(e)}
                placeholder="Select Days"
                options={[]}
              />
            </div>
          </Row>
        </Col>
        <Col span={24} className="p-4 mt-[4px] mb-[100px]">
          <Table
            style={{
              overflow: "hidden",
              fontFamily: "Poppins",
            }}
            rootClassName="expense-transaction-table"
            bordered
            columns={HeaderTransactionData}
            // dataSource={TableData}
            dataSource={[]}
            sortDirections={"ascend"}
            loading={loading ? true : false}
            showSorterTooltip={"sorter-icon"}

            // rowSelection={{
            //   type: selectionType,
            //   ...rowSelection,
            // }}
            // rowSelection={{}}
            // scroll={{y:210}}
          />
        </Col>
      </Row>
      <Prompt
        when={!isEmpty(categories)}
        message="Are you sure you want to leave?"
      />
      {/* <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      /> */}
    </React.Fragment>
  );
};

export default ExpenseTransaction;
